function findEntryScript(page) {
    const scripts = Array.from(page.querySelectorAll('script[src]'));
    return scripts.find((script) => /\/main\.[^/]+\.chunk\.js(?:\?.*)?$/.test(script.src))
        || scripts.reverse().find((script) => script.type === 'module' && script.src);
}

export function runningEntryUrl() {
    const script = findEntryScript(document);
    return script ? script.src : null;
}

export function entryUrlFromHtml(html, documentUrl) {
    const page = new DOMParser().parseFromString(html, 'text/html');
    const script = findEntryScript(page);
    if (!script) return null;

    const base = page.querySelector('base[href]');
    const baseUrl = base ? new URL(base.getAttribute('href'), documentUrl) : documentUrl;
    return new URL(script.getAttribute('src'), baseUrl).href;
}
